export const WIDGET_STATES = {
  PRIMARY_AUTH: 'primary-auth',
  ENROLL_CHOICES: 'enroll-choices',
  ENROLL_TOTP: 'enroll-totp',
  BARCODE_TOTP: 'barcode-totp',
  ACTIVATE_TOTP: 'activate-totp',
  ENROLL_MANUAL_TOTP: 'enroll-manual-totp',
  ENROLL_WEBAUTHN: 'enroll-webauthn',
  MFA_CHALLENGE: 'mfa-challenge',
  MFA_ENROLL: 'mfa-enroll',
  MFA_ENROLL_ACTIVATE: 'mfa-enroll-activate',
  MFA_VERIFY: 'mfa-verify',
  MFA_ENROLL_EMAIL: 'enroll-email',
  MFA_ENROLL_ACTIVATE_EMAIL: 'enroll-activate-email',
  MFA_VERIFY_EMAIL: 'mfa-verify-email',
  MFA_ENROLL_SMS: 'enroll-sms',
  MFA_VERIFY_SMS: 'mfa-verify-sms',
  MFA_VERIFY_GOOGLE_AUTH: 'mfa-verify-google-auth',
  MFA_VERIFY_WEBAUTHN: 'verify-webauthn',
  PASSWORD_EXPIRED: 'password-expired',
  PASSWORD_RESET: 'password-reset',
  FORGOT_PASSWORD: 'forgot-password',
  RECOVERY: 'recovery',
  RECOVERY_CHALLENGE: 'recovery-challenge',
  RECOVERY_QUESTION: 'recovery-question',
  RECOVERY_LOADING: 'recovery-loading',
  LOADING: 'loading',
  UNLOCK_ACCOUNT: 'unlock-account',
  POLL: 'poll',
  SUCCESS: 'success',
};

export const EMAIL_MFA_STATES = [
  WIDGET_STATES.MFA_ENROLL_EMAIL,
  WIDGET_STATES.MFA_ENROLL_ACTIVATE_EMAIL,
  WIDGET_STATES.MFA_VERIFY_EMAIL,
];

export const SMS_MFA_STATES = [
  WIDGET_STATES.MFA_ENROLL_SMS,
  WIDGET_STATES.MFA_VERIFY_SMS,
];

export const TOTP_STATES = [
  WIDGET_STATES.ENROLL_TOTP,
  WIDGET_STATES.BARCODE_TOTP,
  WIDGET_STATES.ACTIVATE_TOTP,
  WIDGET_STATES.ENROLL_MANUAL_TOTP,
  WIDGET_STATES.MFA_VERIFY_GOOGLE_AUTH,
];

export const WEBAUTHN_STATES = [
  WIDGET_STATES.ENROLL_WEBAUTHN,
  WIDGET_STATES.MFA_VERIFY_WEBAUTHN,
];

export const CUSTOM_UI_CONTROLLERS = [
  WIDGET_STATES.PRIMARY_AUTH,
  WIDGET_STATES.ENROLL_CHOICES,
  WIDGET_STATES.PASSWORD_RESET,
  WIDGET_STATES.PASSWORD_EXPIRED,
  ...EMAIL_MFA_STATES,
  ...SMS_MFA_STATES,
  ...TOTP_STATES,
  ...WEBAUTHN_STATES,
];

export const OKTA_INTERNAL_LOADING_STATES = [
  WIDGET_STATES.RECOVERY_LOADING,
  WIDGET_STATES.LOADING,
];

export const shouldShowCustomUI = controller => {
  const normalized = (controller || '').toLowerCase();
  return CUSTOM_UI_CONTROLLERS.includes(normalized);
};

export const isEmailMfaState = controller =>
  EMAIL_MFA_STATES.includes((controller || '').toLowerCase());

export const isSmsMfaState = controller =>
  SMS_MFA_STATES.includes((controller || '').toLowerCase());

export const isTotpState = controller =>
  TOTP_STATES.includes((controller || '').toLowerCase());

export const isWebAuthnState = controller =>
  WEBAUTHN_STATES.includes((controller || '').toLowerCase());
